// ============================================================
// MEDLINKX — EDITABLE PLACEHOLDERS
// ============================================================
export const SITE = {
  brand: "MEDLINKX",
  kitName: "Constipation Care Kit",
  price: "₹799",
  razorpayUrl: "https://rzp.io/rzp/JAzx6XPU",
  whatsappNumber: "917208546240",
  whatsappMessage: "Hi Dr. Burhan, I want to order the Medlinkx Constipation Care Kit for ₹799.",
  instagramUrl: "https://www.instagram.com/drburhanshaikh/",
  linkedinUrl: "https://www.linkedin.com/in/dr-burhan-shaikh-6a0a5b146",
  address: "Healing Hands Clinic, Mehta 531 Complex, Ashram Road, Ahmedabad - 380006, Gujarat",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Healing+Hands+Clinic+Mehta+531+Complex+Ashram+Road+Ahmedabad+380006",
  productDimensions: "40 cm × 22 cm × 17.5 cm",
};

export const waLink = (msg = SITE.whatsappMessage) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(msg)}`;

export const scrollToId = (id) => {
  if (window.__lenis) window.__lenis.scrollTo(id, { offset: -72 });
  else document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
};

// Real product photos uploaded by the brand.
export const IMAGES = {
  hero: "/assets/real-hero.webp",
  doctor: "/assets/doctor-portrait.webp",
  inuse: "/assets/real-inuse.webp",
  antiskid: "/assets/real-antiskid.webp",
  freshener: "/assets/real-freshener.webp",
  footrest: "/assets/real-footrest.webp",
};
